import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog'
import { Button } from '../ui/button'
import { callAPI } from '@/hooks/api'
import { useState } from 'react'
import { Checkbox } from '../ui/checkbox'

interface Props {
  isOpen: boolean
  onHandleSkip: () => void
  onHandleNext: () => void
}

export default function WelcomeNewTrialModal({
  isOpen,
  onHandleSkip,
  onHandleNext,
}: Props) {
  const localAuth = JSON.parse(localStorage.getItem('auth') || '{}')

  const [enableStartupTutorial, setEnableStartupTutorial] = useState(
    localAuth.tutorial
  )
  const handleTutorialChange = () => {
    const endpoint = '/set_tutorial'
    const params = {
      tutorial: !enableStartupTutorial,
      session_key: localAuth.sessionKey,
    }
    callAPI(endpoint, params).then((res) => {
      if (res.status === 'success' && localAuth) {
          localAuth.tutorial = !enableStartupTutorial
          localStorage.setItem('auth', JSON.stringify(localAuth))        
        }
    })
    setEnableStartupTutorial(!enableStartupTutorial)
  }

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(v) => {
        if (!v) {
          onHandleSkip()
        }
      }}
    >
      <DialogContent className="max-w-[480px] !p-8 rounded-lg">
        <DialogHeader>
          <DialogTitle className="md:text-2xl">
            Welcome to your 3 Day Free Trial
          </DialogTitle>
        </DialogHeader>
        <div>
          <p>
            <span className="font-bold">
              {`California's best water rights and ag land use data `}
            </span>
            is now at your fingertips. If you haven't already, be sure to
            download our mobile app to enjoy your Free Trial on-the-go.
          </p>
          <br />
          <p>Now let's take 1 minute to show you around.</p>
          <br />
          <p>
            Click <span className="font-bold">Next</span> to continue with the
            tutorial, or <span className="font-bold">Skip</span> if you would
            prefer to dive right in
          </p>

          <div className="flex items-center space-x-2 mt-6">
            <label
              htmlFor="tutorial-checkbox"
              className="text-base font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              Show tutorial upon startup
            </label>
            <Checkbox
              id="tutorial-checkbox"
              checked={enableStartupTutorial}
              onCheckedChange={handleTutorialChange}
            />
          </div>
        </div>
        <DialogFooter className="sm:justify-between">
          <Button
            className="text-gray-700 pl-0 text-sm uppercase font-bold hover:text-blue-800"
            variant={'ghost'}
            onClick={onHandleSkip}
          >
            Skip
          </Button>
          <Button
            className="h-14 max-w-[114px] w-full hover:bg-[#01589d]"
            onClick={onHandleNext}
          >
            Next
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
